module.exports = __webpack_public_path__ + "img/Recurso 1@300x.e2e7b82f.webp";